export const MINIMUM_USER_CONDITIONS_FOR_COMBINATOR = 2;
export const MINIMUM_EVENT_CONDITIONS_FOR_COMBINATOR = 1;

export const REQUIREMENT_LAYOUT_DATA_TEST = {
  requirementRow: 'requirement-row',
  initialConditionRow: 'initial-condition-row',
  actionButtons: 'qb-ui-requirement-actions',
  conditionActionButtons: 'qb-ui-condition-actions',
  subconditionRow: 'sub-condition-row',
};
